<template>
  <v-row justify="center" class="pt-5">
    <v-col cols="12" md="8" lg="6" id="rc-report" class="pb-4">
      <v-row>
        <v-col cols="12" md="3" class="rc-dark pt-3 font-weight-black title">
          {{ RCProject.name }}
          </v-col>
        <v-col cols="12" md="9" class="pt-3 pr-5" style="position: relative">
          {{ RCProject.description }}

          <v-tooltip v-if="!searching" bottom>
            <template v-slot:activator="{ on }">
              <i v-on="on" class="fas fa-info-circle"></i>
            </template>
            <span>{{ RCProject.source }}</span>
          </v-tooltip>
          <i class="fas fa-trash close rc-close-button" @click="deleteProject"></i>
          <v-form v-if="searching"  class="mt-0 my-2 my-lg-0">
              <v-list v-if="appSearch.length > 0" class="rc-dropdown px-4" >
                <v-list-item-group  >
                  <v-list-item v-for="project in searchMatches" @click="getCost(project)">
                    {{ project.name }}
                  </v-list-item>
                  <v-list-item v-if="searchMatches.length == 0" @click="submitSuggestion">
                    We are sorry, we are not able to find a task based on your search query.
                  </v-list-item>
                </v-list-item-group>
              </v-list>

            <v-text-field dense v-model="appSearch" type="text" class="form-control mt-0" placeholder="Ex. Replace Front Door"></v-text-field>

          </v-form>
          <v-form class="mt-1">
            <v-text-field v-mask="'######'" masked="true" v-if="RCProject.measure" ref="units" @submit.prevent @change="updateUnits" dense :label="'Number of '+RCProject.measure" type="text" class="form-control mt-0 mr-2 rc-whitebg" :placeholder="'How many'+RCProject.measure" :value="RCProject.units"></v-text-field>
          </v-form>


        </v-col>
      </v-row>
      <div class=" mx-4 project-image"  :style="[{backgroundImage: `url(${RCProject.url})`}, {border: 'solid 5px #ffffff'}, {backgroundSize: 'cover'}]">
        <v-container pb-0>
          <v-row v-if="!searching" style="height: 175px">
            <v-col cols="12" md="4" align-self="end" class="pt-5 text-center">
              <div class="mx-3 rc-neutral">
                Low Estimate:<br> {{ RCProject.unitLow ? RCProject.min + (RCProject.unitLow * RCProject.units) : RCProject.min | money }}
              </div>
            </v-col>
            <v-col cols="12" md="4" align-self="end" class="pt-5 text-center">
              <div class="mx-3 rc-neutral">
                Average price:<br> {{ RCProject.unitAvg ? RCProject.avg + (RCProject.unitAvg * RCProject.units) : RCProject.avg | money }}
              </div>
            </v-col>
            <v-col cols="12" md="4" align-self="end" class="col-md-4 pt-5 text-center">
              <div class="mx-3 rc-neutral">
                High Estimate:<br> {{ RCProject.unitHigh ? RCProject.max + (RCProject.unitHigh * RCProject.units) : RCProject.max | money }}
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <v-row justify="center" class="my-0">

        <v-col cols="12" xl="4" sm="6">
          <div @click="dataDialog=true" class="rc-pointer">
            <i class="fas fa-info-circle"></i>
            Where does this data come from?
          </div>
          <v-dialog v-model="dataDialog"
                    max-width="500"
          >
            <v-card>
              <v-card-title
                      class="headline grey lighten-2"
                      primary-title
              >
                Where does this data come from?
              </v-card-title>

              <v-card-text>
                Cost data is based on actual project costs as reported by HomeAdvisor members.
                How do we get this data?
                Homeowners visit HomeAdvisor.com to find a top-rated pro to complete their home improvement project or repair.
                Once their projects are completed, the members log in to their accounts and complete a short cost survey.
                After compiling and organizing the data, we report it back to you.
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>

      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import {mask} from 'vue-the-mask';
  export default {
    directives: {mask},
    methods: {
      getCost(selection) {
        this.APIId = selection.id;
        this.searching = false;
        console.log('token', this.$route.params.token);
        let urlString = this.$route.params.token ? `add/${selection.apiId}/${this.$route.params.token}`: `add/${selection.apiId}/demo`;
        let zipObj = { zip: this.zip };
        this.$http.post(urlString, JSON.stringify(zipObj))
                .then(response => {
                  let responseObject = response.body;
                  console.log(responseObject);
                  let responseObjectJson = JSON.parse(responseObject);
                  console.log('response', responseObjectJson);
                  this.response = responseObjectJson;
                  console.log(typeof this.response);
                  let projectInfo = {};
                  projectInfo = {
                    name: selection.name,
                    listId: this.RCId,
                    apiId: this.APIId,
                    min: this.response.min,
                    avg: this.response.avg,
                    max: this.response.max,
                    url: selection.url,
                    source: this.response.source
                  };
                  projectInfo.description = this.response.description;
                  projectInfo.projectId = this.response.projectId;
                  projectInfo.measure = this.response.measure;
                  projectInfo.unitLow = this.response.unitLow;
                  projectInfo.unitAvg = this.response.unitAvg;
                  projectInfo.unitHigh = this.response.unitHigh;
                  projectInfo.units = 1;

                  this.RCProject = projectInfo;
                  this.$emit('identifyProject', projectInfo);
                });



      },
  deleteProject() {

  
  const token = this.$route.params.token;

  if (!token) {

  

    this.$emit(
      'deleteError',
      'Authentication token is missing.'
    );

    return;
  }

  this.$http.delete(
    `delete/${this.RCProject.projectId}`,
    {
      headers: {
        'X-Repair-Token': token
      }
    }
  )
  .then(response => {

  
    this.$emit(
      'deleteProject',
      this.RCProject.listId
    );

  })
  .catch(error => {

    const status = error && error.response
      ? error.response.status
      : null;

    if (status === 401) {

  

      this.$emit(
        'deleteError',
        'You are not authorized to perform this action.'
      );

    } else if (status === 403) {

     

      this.$emit(
        'deleteError',
        'You do not have permission to delete this project.'
      );

    } else if (status === 404) {

   
      this.$emit(
        'deleteError',
        'Project could not be found.'
      );

    } else {

     

      this.$emit(
        'deleteError',
        'An unexpected error occurred. Please try again.'
      );
    }
  });
},
      submitSuggestion() {
        let suggestionObj = {
          suggestion: this.appSearch
        };
        this.$http.post(`suggestion/submit`, JSON.stringify(suggestionObj)).then(response => {
          console.log(response);
        }, error => {
          console.log(error);
        });
      },
      updateUnits(event) {
        this.RCProject.units = event;
        console.log('RCProject updated units: ', this.RCProject);
        this.$emit('identifyProject', this.RCProject);
        this.$http.post(`update/${this.RCProject.projectId}/${this.$route.params.token}`, `{"units": ${this.RCProject.units}}`)
                .then(response => {
                  console.log('Update Units Response: ',response);
                });
      }
    },
    props: ['RCId', 'RCProject', 'keys', 'zip'],
    data: function () {
      return {
        appSearch: '',
        searching: true,
        APIId: '',
        imageUrl:'https://cpsrecall.s3-us-west-2.amazonaws.com/RepairCalculatorImgs/CalculatorDefault.jpg',
        response: {},
        dataDialog: false
      };
    },
    computed: {
      searchMatches: function () {
        let matchesArray = [];
        if (this.appSearch.length < 1) {
          console.log('no dice');
          return matchesArray;
        }
        let key = 0;
        for (key in this.keys) {
          let rcRegEx = new RegExp(this.appSearch, 'i');
          if (this.keys[key].name.search(rcRegEx) > -1) {

            matchesArray.push(this.keys[key]);
          }
        }
        return matchesArray;
      }
    },
    created: function() {
      console.log('Created');
      if(this.RCProject.apiId > 0) {
        console.log('RCProject ', this.RCProject);
        this.searching = false;
      }
    },
    updated: function() {
      if(this.RCProject.apiId > 0) {
        this.searching = false;
      }
    },
    filters: {
      money: (value) => {
        if (!value) return '';
        value = value.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
        return value;
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .rc-dropdown {
    position: absolute !important;
    transform: translate3d(388px, 38px, 0px);
    top: 12px;
    left: -377px;
    will-change: transform;
    z-index: 1000;
    max-height: 300px;
    overflow: scroll;
  }
  .rc-close-button {
    position: absolute;
    top: 10px;
    right: 15px;
    cursor: pointer;
  }
  .rc-info {
    position: absolute;
    top: 20px;
    right: 40px;
    /*color: white;*/
  }
  .rc-neutral {
    background-color: rgb(75, 75, 75);
    color: #ffffff;
  }

  @media (max-width: 960px) {
    .rc-close-button {
      top: -50px;
    }

  }




</style>
